module.exports = function() {
  return new Worker(__webpack_public_path__ + "e1c875ba85990531591b.worker.js");
};